// extracted by mini-css-extract-plugin
export default {"senderName":"ChatMessageSenderName_senderName__sgHDe"};